import React, {useContext} from 'react';
import styled, {ThemeContext} from 'styled-components';
import {Box, Columns, Column, Container, breakpoint, p} from '@nib/layout';
import Copy from '@nib-components/copy';
import Link from '@nib-components/link';

const CDN_BASEURL = 'https://static.nib.com.au/images/nib/mds/footer';

const IMAGE_PATHS = {
  BACKGROUND_SMALL: `${CDN_BASEURL}/RAP-bg-small.png`,
  BACKGROUND_LARGE: `${CDN_BASEURL}/RAP-bg-large.png`,
  ARTWORK_SMALL: `${CDN_BASEURL}/RAP-artwork.png`,
  ARTWORK_LARGE: `${CDN_BASEURL}/RAP-artwork@2x.png`
};

export const BasicAcknowledgmentOfCountry = () => (
  <Box paddingHorizontal={5} paddingTop={{xs: 7, md: 5}} paddingBottom={7}>
    <Container>
      <Copy size="small" measure={false}>
        We acknowledge Aboriginal and Torres Strait Islander peoples as the Traditional Custodians of the lands where we live, learn and work.{' '}
        <Link color="light" id="ga-footer-reconciliation-action-plan" href="https://www.nib.com.au/docs/reconciliation-action-plan">
          View our Reconciliation Action Plan
        </Link>
      </Copy>
    </Container>
  </Box>
);

BasicAcknowledgmentOfCountry.displayName = 'BasicAcknowledgmentOfCountry';

const COLLAPSE_BREAKPOINT = 'sm';

const Background = styled.div`
  position: relative;

  // We do not have a darker trueGreen shade currently
  background-color: hsla(0, 0%, 0%, 0.42);

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;

    opacity: 0.1;

    background-image: url(${IMAGE_PATHS.BACKGROUND_SMALL});
    background-size: 200%;
    background-position: center;
    background-repeat: no-repeat;

    ${breakpoint(COLLAPSE_BREAKPOINT)`
      background-size: 100%;
    `}

    ${breakpoint('lg')`
      background-image: url(${IMAGE_PATHS.BACKGROUND_LARGE});
    `}

    ${breakpoint('xxxl')`
      background-size: 1600px auto;
    `}
  }
`;

const Wrapper = styled.div`
  position: relative;
  z-index: 0;
  ${p(5)};
`;

export const RAPImg = styled.img`
  width: auto;
  height: 12rem;

  ${breakpoint(COLLAPSE_BREAKPOINT)`
    height: 8rem;
  `}
`;

export const AcknowledgmentOfCountry = () => {
  const themeContext = useContext(ThemeContext);
  const nibBrands = ['nib', 'foundation'];

  if (!nibBrands.includes(themeContext.id)) {
    return <BasicAcknowledgmentOfCountry />;
  }

  return (
    <Background>
      <Wrapper>
        <Container>
          <Columns space={5} collapseBelow={COLLAPSE_BREAKPOINT} align="center" verticalAlign="center">
            <Column width="content">
              <Box textAlign="center">
                <RAPImg
                  srcSet={`${IMAGE_PATHS.ARTWORK_SMALL}, ${IMAGE_PATHS.ARTWORK_LARGE} 2x`}
                  src={IMAGE_PATHS.ARTWORK_SMALL}
                  alt="nib's 'the beginning' artwork by Michelle Kerrin"
                  height="128"
                  width="95"
                />
              </Box>
            </Column>
            <Column>
              <Box padding={4} background="trueGreen" borderRadius="standard">
                <Copy size="small" measure={false}>
                  We acknowledge Aboriginal and Torres Strait Islander peoples as the Traditional Custodians of the lands where we live, learn and work.{' '}
                  <Link color="light" id="ga-footer-reconciliation-action-plan" href="https://www.nib.com.au/docs/reconciliation-action-plan">
                    View our Reconciliation Action Plan
                  </Link>
                </Copy>
              </Box>
            </Column>
          </Columns>
        </Container>
      </Wrapper>
    </Background>
  );
};

AcknowledgmentOfCountry.displayName = 'AcknowledgmentOfCountry';
